import { ButtonLink, Flex, Select, TextInput } from '@applyboard/crystal-ui';
import { PersonAddOutlineIcon } from '@applyboard/ui-icons';
import { useState } from 'react';

interface OptionProps {
  label: string;
  value: string;
  disabled?: boolean;
}

const FilterableKeys = ['name'] as const;
type FilterableKey = (typeof FilterableKeys)[number];

type AgencyManagementHeadingProps = Readonly<{
  canCreateAgency: boolean;
  onFilterChange: (searchText: string, filter: string) => void;
}>;

export function AgencyManagementHeading({
  canCreateAgency,
  onFilterChange,
}: AgencyManagementHeadingProps): JSX.Element {
  const [filter, setFilter] = useState<FilterableKey>('name');
  const [search, setSearch] = useState('');

  const FILTER_OPTIONS: Array<OptionProps> = [
    {
      label: 'Agency Name',
      value: 'name',
    },
  ];

  const handleChangeFilter = (newFilter: string) => {
    if (isValidFilterKey(newFilter)) {
      setFilter(newFilter);
      onFilterChange(search, newFilter);
    }
  };

  const handleSearchChange = (newSearch: string) => {
    setSearch(newSearch);
    onFilterChange(newSearch, filter);
  };

  const isValidFilterKey = (filterKey: string): filterKey is FilterableKey => {
    return FilterableKeys.includes(filterKey as FilterableKey);
  };

  return (
    <Flex pt={{ xs: 2, sm: 8 }} justify="end" align="center" gap={5}>
      <TextInput
        disabled={!isValidFilterKey(filter)}
        helpText=""
        aria-label="search"
        intent="secondary"
        onChange={handleSearchChange}
        placeholder="Search"
        size="md"
        type="search"
        value={search}
      />
      <Flex gap={2} align="center">
        <Select
          appearance="native"
          aria-label="filter options"
          onChange={handleChangeFilter}
          value={filter}
          placeholder=""
        >
          {FILTER_OPTIONS.map((option) => (
            <Select.Option value={option.value} label={option.label} key={option.value} />
          ))}
        </Select>
      </Flex>
      {canCreateAgency && (
        <ButtonLink
          href="/profiles/agencies/add"
          leadIcon={PersonAddOutlineIcon}
          intent="primary"
          size="md"
          width="hug"
        >
          Add agency
        </ButtonLink>
      )}
    </Flex>
  );
}
